import { EuiButton, EuiFlexGroup, EuiFlexItem, EuiModal, EuiModalBody, EuiModalFooter, EuiModalHeader, EuiModalHeaderTitle, EuiOverlayMask, EuiText } from '@elastic/eui';
import React, { useMemo } from 'react';

interface Props{
  onClose(response:any):any;
  isOpen?: boolean;
  className?:string;
  text:string;
  title?:string;
}

export const ModalYesNoText = (props:Props) =>{

  let {onClose, isOpen, text, title} = props;

  const getFooter = useMemo(() =>{
      return(
        <EuiModalFooter>
          <EuiFlexGroup justifyContent="spaceBetween">
          <EuiFlexItem>
              <EuiButton onClick={()=>onClose(true)}>Si</EuiButton>
          </EuiFlexItem>
          <EuiFlexItem>
              <EuiButton color="danger" onClick={()=>onClose(false)}>No</EuiButton>
          </EuiFlexItem>
          </EuiFlexGroup>
        </EuiModalFooter>
      )
  },[onClose])

  const getContent = () => {
      return (
        <EuiText textAlign="left"><h3><p dangerouslySetInnerHTML={{__html: text}}/></h3></EuiText>
      );
  }

  return isOpen ? (
    <EuiOverlayMask>
      <EuiModal id="modalYesNoText" onClose={()=>onClose}  maxWidth={false}>
        <EuiModalHeader>
          <EuiModalHeaderTitle>{title}</EuiModalHeaderTitle>
        </EuiModalHeader>
        <EuiModalBody>
          {getContent()}
        </EuiModalBody>
        { getFooter }
      </EuiModal>
    </EuiOverlayMask>
  ) : null
}
export default ModalYesNoText;